export const starkregenConstants = {
  SHOW_VELOCITY: "SHOW_VELOCITY",
  SHOW_HEIGHTS: "SHOW_HEIGHTS",
  SHOW_TIMESERIES: "SHOW_TIMESERIES",
  SHOW_MAXVALUES: "SHOW_MAXVALUES",
};
